import React from 'react';
import './LoginPage.css';

export const LoginPage: React.FC = () => {
  const handleMicrosoftLogin = () => {
    // Redirect to backend OAuth endpoint
    window.location.href = '/auth/login';
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img 
            src="/AACC-Banner.png" 
            alt="AACC Banner" 
            className="login-banner"
          />
          <h1>Emberbridge Admin Portal</h1>
          <p className="login-subtitle">
            Secure access to data synchronization between Brushfire and HubSpot
          </p>
        </div>

        <div className="login-content">
          <button 
            onClick={handleMicrosoftLogin}
            className="microsoft-login-btn"
          >
            <div className="microsoft-logo">
              <svg width="21" height="21" viewBox="0 0 21 21" fill="none">
                <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
                <rect x="12" y="1" width="9" height="9" fill="#00a4ef"/>
                <rect x="1" y="12" width="9" height="9" fill="#ffb900"/>
                <rect x="12" y="12" width="9" height="9" fill="#7fba00"/>
              </svg>
            </div>
            <span>Sign in with Microsoft 365</span>
          </button>

          <div className="login-info">
            <p>
              <strong>Secure Authentication:</strong> This portal uses your company's 
              Microsoft 365 credentials for secure access.
            </p>
            <ul>
              <li>Multi-factor authentication supported</li>
              <li>No passwords stored locally</li>
              <li>Session automatically expires for security</li>
            </ul>
          </div>
        </div>

        <div className="login-footer">
          <p>© 2025 Emberbridge Sync Portal</p>
        </div>
      </div>
    </div>
  );
};
